import { render, staticRenderFns } from "./About.vue?vue&type=template&id=dc1f40e2&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=dc1f40e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1f40e2",
  null
  
)

export default component.exports